<template>
    <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
    <router-view />
    <InfoModal />
    <ConfirmModal />
    <SuccessModal />
    <DeclineModal />
</template>

<script>
import InfoModal from "@/components/modals/InfoModal.vue";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import DeclineModal from "@/components/modals/DeclineModal.vue";
import axios from "axios";
import { API_BASE_URL } from "./modules/api-base-url";
import { mapMutations } from "vuex";
import { initSessionGuard, destroySessionGuard } from "@/modules/session-guard";

export default {
    components: {
        InfoModal,
        ConfirmModal,
        SuccessModal,
        DeclineModal,
    },
    mounted() {
        // Ініціалізуємо session guard: inactivity (3 год) + зміна дня → reset + redirect
        initSessionGuard();

        const hash = window.location.hash;
        const urlParams = new URLSearchParams(hash.substring(3));
        const action = urlParams.get("action");

        const addEvent = JSON.parse(localStorage.getItem("addEvent"));
        const setBase = JSON.parse(localStorage.getItem("setBase"));
        const sendMessageToTelegramm = JSON.parse(localStorage.getItem("sendMessageToTelegramm"));

        if (action === "decline") {
            this.clearLocalStorage();
            this.SET_DECLINE(true);
        }

        if (action !== "approved" || !addEvent || !setBase || !sendMessageToTelegramm) {
            return;
        }

        const addEventFormData = objectToFormData(addEvent);
        const sendMessageToTelegrammFormData = objectToFormData(sendMessageToTelegramm);

        const userMailData = new FormData();
        userMailData.append("email", sendMessageToTelegramm.user_email);
        userMailData.append("date", sendMessageToTelegramm.date);
        userMailData.append("consultant", sendMessageToTelegramm.consultant);

        const requests = [
            axios.post(API_BASE_URL + "/mit-backend/add-event.php", addEventFormData),
            axios.get(API_BASE_URL + "/mit-backend/set_base.php", { params: setBase }), // `get` не підтримує FormData
            axios.post(API_BASE_URL + "/mit-backend/send-message-to-telegram.php", sendMessageToTelegrammFormData),
            axios.post(API_BASE_URL + "/mit-backend/send_client_email.php", userMailData),
            axios.post(API_BASE_URL + "/mit-backend/send_consultant_email.php", sendMessageToTelegrammFormData),
        ];

        Promise.all(requests)
            .then((responses) => {
                console.log("Responses:", responses);

                this.clearLocalStorage();
                this.SET_SUCCESS(true);

                // Прибирання query-параметра
                const newUrl = window.location.href.split("#")[0];
                history.replaceState(null, "", newUrl);
            })
            .catch((error) => {
                console.error("Error:", error);
            });

        function objectToFormData(obj) {
            const formData = new FormData();
            for (const key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    // Якщо значення - об'єкт або масив, перетворюємо його на JSON-рядок
                    const value = typeof obj[key] === "object" ? JSON.stringify(obj[key]) : obj[key];
                    formData.append(key, value);
                }
            }
            return formData;
        }
    },

    methods: {
        ...mapMutations("UI", ["SET_SUCCESS", "SET_DECLINE"]),

        clearLocalStorage() {
            // Видалення даних з localStorage
            localStorage.removeItem("addEvent");
            localStorage.removeItem("setBase");
            localStorage.removeItem("sendMessageToTelegramm");

            console.log("Дані видалено з localStorage та прибрано query-параметр.");
        },
    },

    beforeUnmount() {
        destroySessionGuard();
    },
};
</script>

<style lang="scss" src="./scss/style.scss"></style>
